module.exports = __webpack_public_path__ + "img/pennsylvania-anti-slavery-society.4aa66cc9.png";